import Vue from 'vue';
import '@trusense/system';

import TruSenseLang from '@trusense/language';
import Aqua, { registerAllComponents } from '@trusense/aqua';

import App from './App.vue';
import language from './i18n';

import './assets/scss/main.scss';

Vue.config.productionTip = false;

Vue.use(Aqua);

registerAllComponents();

Vue.use(TruSenseLang, {
  language,
  scope: 'documentation',
  languages: ['es', 'en'],
});

new Vue({
  render: (h: any) => h(App),
  i18n: (global as any).i18nt.documentation,
}).$mount('#app');
